import * as config from '../settings/global';
import React from 'react';
import { store } from '../redux/store'
import PropTypes from 'prop-types'
import { isStackSupportedByUser } from "../helpers/data/_handlers/plans";
import Icon from "./Icon";

const ICON_DUPLICATES = [
    {base: 'akeneo', codes: ['akeneo-dev']},
    {base: 'drupal', codes: ['drupal-dev']},
    {base: 'wordpress', codes: ['wordpress-dev']},
    {base: 'laravel', codes: ['laravel-formula']},
    {base: 'plesk', codes: ['plesk-docker']},
    {base: 'pimcore', codes: ['pimcore-dev']},
    {base: 'symfony', codes: ['symfony-restful']},
    {base: 'orocrm', codes: ['orocommerce']},
];

class StackIcon extends React.Component { // for appInfo & deployPage headers

    // geometry - Object with app codes and inline styles, that requires custom appearance
    // className - for custom className
    // code - apps code

    constructor(props) {
        super(props);

        this.state = {
            isMounted: false,
            svgIcon: null,
            style : null,
        }
    }

    componentDidMount() {
        this.setState({isMounted: true});
        let {code, geometry} = this.props;
        // in order to optimise icons UI, try to render image without checking it's presence in files by request or async func
        // it ok, if icon is not presented in files - it will be replaced later
        let actualIconName = this.getOriginalIcon(code);
        this.setState({
            svgIcon: actualIconName,
            style: this.getImageStyle(code, geometry),
        });
    }

    getOriginalIcon = svgIcon => { // define if icon for stack with complex codename already exist for another one

        if (!svgIcon) { // exception
            if (config.DEBUG) console.error('No stack code provided for icon');
            return
        }

        let foundBaseForDuplicate = ICON_DUPLICATES.find(stack => stack.codes.includes(svgIcon));

        return foundBaseForDuplicate ? foundBaseForDuplicate['base'] : svgIcon
    };

    getImageStyle = (svgIcon, geometry) => {

        let geometryPassed = geometry && !!Object.keys(geometry).length;
        let iconHasOptions = geometryPassed &&  geometry[svgIcon] && !!Object.keys(geometry[svgIcon]).length;

        return iconHasOptions ? geometry[svgIcon] : {}
    };

    render() {

        let {svgIcon, style} = this.state;
        let {code, name, plan, icon, fallbackImages} = this.props;
        let className = this.props.className ? ' ' + this.props.className : '';
        let {user} = store.getState().userData;
        let {deployments_left} = user ? user : {};

        return (
            <div className={`common-stack-icon${className}`}
                 style={style}
            >
                <Icon
                    className='common-stack-icon__img'
                    icon={icon}
                    alt={`${name || code} icon`}
                    fallbackImages={!!fallbackImages?.length ? fallbackImages : undefined}
                    // height={this.props.height}
                    // width={this.props.width}
                    // optimize
                    height={90}
                    width={90}
                    optimize
                />
                {
                    code.includes('-dev') &&
                    <div className='common-stack-icon__dev'>
                        <i className={'fas fa-cog common-stack-icon__dev__icon'} aria-hidden="true"/>
                    </div>
                }
                {/*{*/}
                {/*    code.includes('-formula') &&*/}
                {/*    <div className='common-stack-icon__formula'>*/}
                {/*        <i className={'fas fa-cubes common-stack-icon__formula__icon'} aria-hidden="true"/>*/}
                {/*    </div>*/}
                {/*}*/}
                {
                    (!!this.state.isMounted && !!plan && (!isStackSupportedByUser(plan) || deployments_left === 0)) &&
                    <div className={`common-stack-icon__not-free${code.includes('-dev') ? ' common-stack-icon__not-free--second' : ''}`}>
                        <i className={'fas fa-shopping-cart common-stack-icon__not-free__icon'} aria-hidden="true"/>
                    </div>
                }
            </div>
        );
    }
}

StackIcon.propTypes = {
    icon: PropTypes.object,
    geometry: PropTypes.object,
    className: PropTypes.string,
    code: PropTypes.string,
};

export default StackIcon